import React, { useEffect, useState } from 'react';
import { Tabs, Tab, ToggleButtonGroup, ToggleButton } from 'react-bootstrap';
import PropTypes from 'prop-types';

import useBUState from 'global/buState';
import useCheckPlantState from 'global/checkPlantState';
import usePlantState from 'global/plantState';
import comma from 'utils/format/comma';

/**
 * 공장 선택
 */
const CheckPlant = ({ value }) => {
  /* recoil */
  const { bu } = useBUState();
  const {
    plant: { hasReads: hasReadPlants }
  } = usePlantState();
  const { checkPlant, setCheckPlant } = useCheckPlantState();

  /* state */
  // 선택한 BU
  const [selectBU, setSelectBU] = useState('');

  /* watch */
  useEffect(() => {
    if (value.length > 0) {
      setCheckPlant(value);
    }
  }, [value]);
  useEffect(() => {
    // 조회 권한이 있는 공장이 속한 첫번째 BU 선택
    if (!selectBU) {
      setSelectBU(
        bu.find(({ buCode } = {}) =>
          checkPlant.some(value =>
            hasReadPlants.some(
              ({ seq, buCode: bu } = {}) => bu === buCode && seq === value
            )
          )
        )?.buCode ?? ''
      );
    }
  }, [bu, hasReadPlants, checkPlant]);

  /* view */
  return (
    <Tabs activeKey={selectBU} onSelect={setSelectBU}>
      {bu.map(({ buCode, buName } = {}) => (
        // title 옆 괄호 안에 숫자는 공장 선택한 갯수 표현
        <Tab
          key={`bu.${buCode}`}
          eventKey={buCode}
          title={`${buName}(${comma(
            checkPlant.filter(value =>
              hasReadPlants.some(
                ({ seq, buCode: bu } = {}) => bu === buCode && seq === value
              )
            ).length
          )})`}
          className="border-bottom border-x p-3"
        >
          <ToggleButtonGroup
            type="checkbox"
            value={checkPlant}
            onChange={setCheckPlant}
          >
            {hasReadPlants
              .filter(({ buCode } = {}) => buCode === selectBU)
              .map(({ seq, pltCode } = {}) => (
                <ToggleButton
                  key={`hasReadPlants.${pltCode}`}
                  id={`hasReadPlants.${pltCode}`}
                  value={seq}
                  className="mb-0"
                  size="sm"
                  variant="outline-success"
                >
                  {pltCode}
                </ToggleButton>
              ))}
          </ToggleButtonGroup>
        </Tab>
      ))}
    </Tabs>
  );
};

CheckPlant.propTypes = {
  // 값
  value: PropTypes.arrayOf(PropTypes.number)
};
CheckPlant.defaultProps = { value: [] };

export default CheckPlant;
